<div class="resultat-details-container p-4">
  <!-- Informations du titre -->
  <div class="titre-info-card mb-4 p-3 surface-50 border-round" *ngIf="titre">
    <div class="grid">
      <div class="col-12 md:col-6">
        <div class="field-info">
          <label class="font-semibold text-600">Code ISIN:</label>
          <span class="ml-2">{{ titre.isin || 'N/A' }}</span>
        </div>
      </div>
      <div class="col-12 md:col-6">
        <div class="field-info">
          <label class="font-semibold text-600">Instrument:</label>
          <span class="ml-2">{{ titre.typeInstrument }}</span>
        </div>
      </div>
      <div class="col-12 md:col-6">
        <div class="field-info">
          <label class="font-semibold text-600">Date d'opération:</label>
          <span class="ml-2">{{ titre.operationDate | date:'dd/MM/yyyy' }}</span>
        </div>
      </div>
      <div class="col-12 md:col-6">
        <div class="field-info">
          <label class="font-semibold text-600">Date de valeur:</label>
          <span class="ml-2">{{ titre.valueDate | date:'dd/MM/yyyy' }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Formulaire des résultats -->
  <h3 class="text-primary mb-3">Résultats de l'adjudication</h3>

  <form [formGroup]="formGroup" class="flex flex-column gap-4 mb-4">
    <!-- Montant sollicité -->
    <div class="flex flex-column gap-2">
      <label for="montantSollicite" class="font-medium">Montant sollicité (millions de FCFA) <span class="text-red-500">*</span></label>
      <p-inputNumber
        id="montantSollicite"
        formControlName="montantSollicite"
        mode="decimal"
        [minFractionDigits]="0"
        [maxFractionDigits]="4"
        [ngClass]="{'ng-invalid ng-dirty': formGroup.get('montantSollicite')?.invalid && formGroup.get('montantSollicite')?.touched}">
      </p-inputNumber>
      <small class="text-red-500" *ngIf="formGroup.get('montantSollicite')?.invalid && formGroup.get('montantSollicite')?.touched">
        Le montant sollicité est obligatoire
      </small>
    </div>

    <!-- Montant global des soumissions -->
    <div class="flex flex-column gap-2">
      <label for="montantGlobalSoumissions" class="font-medium">Montant global des soumissions (millions de FCFA) <span class="text-red-500">*</span></label>
      <p-inputNumber
        id="montantGlobalSoumissions"
        formControlName="montantGlobalSoumissions"
        mode="decimal"
        [minFractionDigits]="0"
        [maxFractionDigits]="4"
        [ngClass]="{'ng-invalid ng-dirty': formGroup.get('montantGlobalSoumissions')?.invalid && formGroup.get('montantGlobalSoumissions')?.touched}">
      </p-inputNumber>
      <small class="text-red-500" *ngIf="formGroup.get('montantGlobalSoumissions')?.invalid && formGroup.get('montantGlobalSoumissions')?.touched">
        Le montant global des soumissions est obligatoire
      </small>
    </div>

    <!-- Taux moyen pondéré -->
    <div class="flex flex-column gap-2">
      <label for="tauxMoyenPondere" class="font-medium">Taux moyen pondéré (%) <span class="text-red-500">*</span></label>
      <p-inputNumber
        id="tauxMoyenPondere"
        formControlName="tauxMoyenPondere"
        mode="decimal"
        [minFractionDigits]="0"
        [maxFractionDigits]="4"
        [ngClass]="{'ng-invalid ng-dirty': formGroup.get('tauxMoyenPondere')?.invalid && formGroup.get('tauxMoyenPondere')?.touched}">
      </p-inputNumber>
      <small class="text-red-500" *ngIf="formGroup.get('tauxMoyenPondere')?.invalid && formGroup.get('tauxMoyenPondere')?.touched">
        Le taux moyen pondéré est obligatoire
      </small>
    </div>

    <!-- Taux marginal -->
    <div class="flex flex-column gap-2">
      <label for="tauxMarginal" class="font-medium">Taux marginal (%) <span class="text-red-500">*</span></label>
      <p-inputNumber
        id="tauxMarginal"
        formControlName="tauxMarginal"
        mode="decimal"
        [minFractionDigits]="0"
        [maxFractionDigits]="4"
        [ngClass]="{'ng-invalid ng-dirty': formGroup.get('tauxMarginal')?.invalid && formGroup.get('tauxMarginal')?.touched}">
      </p-inputNumber>
      <small class="text-red-500" *ngIf="formGroup.get('tauxMarginal')?.invalid && formGroup.get('tauxMarginal')?.touched">
        Le taux marginal est obligatoire
      </small>
    </div>

    <!-- Nombre de soumissions -->
    <div class="flex flex-column gap-2">
      <label for="nombreSoumissions" class="font-medium">Nombre de soumissions <span class="text-red-500">*</span></label>
      <p-inputNumber
        id="nombreSoumissions"
        formControlName="nombreSoumissions"
        [showButtons]="false"
        [ngClass]="{'ng-invalid ng-dirty': formGroup.get('nombreSoumissions')?.invalid && formGroup.get('nombreSoumissions')?.touched}">
      </p-inputNumber>
      <small class="text-red-500" *ngIf="formGroup.get('nombreSoumissions')?.invalid && formGroup.get('nombreSoumissions')?.touched">
        Le nombre de soumissions est obligatoire
      </small>
    </div>

    <!-- Soumissions retenues -->
    <div class="flex flex-column gap-2">
      <label for="soumissionsRetenues" class="font-medium">Soumissions retenues (millions de FCFA) <span class="text-red-500">*</span></label>
      <p-inputNumber
        id="soumissionsRetenues"
        formControlName="soumissionsRetenues"
        mode="decimal"
        [minFractionDigits]="0"
        [maxFractionDigits]="4"
        [ngClass]="{'ng-invalid ng-dirty': formGroup.get('soumissionsRetenues')?.invalid && formGroup.get('soumissionsRetenues')?.touched}">
      </p-inputNumber>
      <small class="text-red-500" *ngIf="formGroup.get('soumissionsRetenues')?.invalid && formGroup.get('soumissionsRetenues')?.touched">
        Les soumissions retenues sont obligatoires
      </small>
    </div>

    <!-- Rendement moyen pondéré -->
    <div class="flex flex-column gap-2">
      <label for="rendementMoyenPondere" class="font-medium">Rendement moyen pondéré (%) <span class="text-red-500">*</span></label>
      <p-inputNumber
        id="rendementMoyenPondere"
        formControlName="rendementMoyenPondere"
        mode="decimal"
        [minFractionDigits]="0"
        [maxFractionDigits]="4"
        [ngClass]="{'ng-invalid ng-dirty': formGroup.get('rendementMoyenPondere')?.invalid && formGroup.get('rendementMoyenPondere')?.touched}">
      </p-inputNumber>
      <small class="text-red-500" *ngIf="formGroup.get('rendementMoyenPondere')?.invalid && formGroup.get('rendementMoyenPondere')?.touched">
        Le rendement moyen pondéré est obligatoire
      </small>
    </div>
  </form>

  <!-- Boutons d'action en mode édition (création ou modification) -->
  <div class="flex justify-content-end gap-2 mt-4" *ngIf="!isView || isEditMode">
    <p-button
      label="Annuler"
      icon="pi pi-times"
      (onClick)="cancel()"
      severity="secondary"
      [outlined]="true">
    </p-button>
    <p-button
      label="Enregistrer"
      icon="pi pi-check"
      (onClick)="save()"
      severity="primary">
    </p-button>
  </div>

  <!-- Boutons en mode consultation -->
  <div class="flex justify-content-end gap-2 mt-4" *ngIf="isView && !isEditMode && resultatId">
    <p-button
      label="Fermer"
      icon="pi pi-times"
      (onClick)="cancel()"
      severity="secondary"
      [outlined]="true">
    </p-button>
    <p-button
      label="Modifier"
      icon="pi pi-pencil"
      (onClick)="enableEdit()"
      severity="primary">
    </p-button>
  </div>
</div>
